import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, DOC_GEN_ENDPOINTS } from "../apiEndpoints";

export const generateDocumentApi = (endpoint, formData) =>
  apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}/${endpoint}`, formData);

export const generateDocumentStreamApi = (name, formData, signal) =>
  apiClient.stream(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.GENERATE_DOCUMENT}?name=${name}&stream=true`,
    formData,
    signal,
  );

export const getDocumentListApi = (type) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.GET_DOCUMENT_LIST}?type=${type}`,
  );

export const getPetitionTypesApi = () => getDocumentListApi("petition");

export const getApplicationTypesApi = () => getDocumentListApi("application");

export const getContractTypesApi = () => getDocumentListApi("contract");

export const getDocumentConfigApi = (endpoint) =>
  apiClient.get(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}/${endpoint}`);

export const getDocumentSchemaApi = (name) =>
  apiClient.get(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.GET_DOCUMENT_SCHEMA}?name=${name}`,
  );

export const updatePetitionContentApi = (userId, chatId, content, timestamp) =>
  apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.UPDATE_PETITION}`, {
    user_id: userId,
    chat_id: chatId,
    Document: content,
    Timestamp: timestamp,
  });

export const updateApplicationContentApi = (
  userId,
  chatId,
  content,
  timestamp,
) =>
  apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.UPDATE_APPLICATION}`, {
    user_id: userId,
    chat_id: chatId,
    Document: content,
    Timestamp: timestamp,
  });

// export const deletePetitionApi = (userId, chatId) =>
//   apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.DELETE_PETITION}`, {
//     user_id: userId,
//     chat_id: chatId,
//   });

// export const getPetitionHistoryApi = (userId) =>
//   apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.PETITION_HISTORY}`, {
//     user_id: userId,
//   });

// export const deleteApplicationApi = (userId, chatId) =>
//   apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.DELETE_APPLICATION}`, {
//     user_id: userId,
//     chat_id: chatId,
//   });

// export const getApplicationHistoryApi = (userId) =>
//   apiClient.post(`${BACKEND_ENDPOINTS.AI_API_BASE_URL}${DOC_GEN_ENDPOINTS.APPLICATION_HISTORY}`, {
//     user_id: userId,
//   });
